var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M3.996 4a2 2 0 0 1 2-2h8l6 6v12a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m13.996 2 6 6h-4a2 2 0 0 1-2-2z",
  opacity: 0.25
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.097 11.958c-.27 0-.524.101-.71.276l-2.955 2.787a1.48 1.48 0 0 0-.474 1.075c0 .4.169.787.474 1.075a1.7 1.7 0 0 0 1.165.454 1.7 1.7 0 0 0 1.165-.454l2.954-2.786a.292.292 0 0 1 .4.424l-2.954 2.787a2.28 2.28 0 0 1-1.565.612 2.28 2.28 0 0 1-1.565-.612 2.06 2.06 0 0 1-.657-1.5c0-.566.239-1.105.657-1.5l2.955-2.786c.297-.28.697-.435 1.11-.435s.813.155 1.11.435.468.665.468 1.07-.17.79-.468 1.07l-2.958 2.788a.96.96 0 0 1-.655.257.96.96 0 0 1-.655-.258.88.88 0 0 1-.28-.64c0-.245.103-.475.28-.642l2.047-1.929a.292.292 0 1 1 .4.425l-2.047 1.928a.3.3 0 0 0-.097.217c0 .078.033.157.097.217a.37.37 0 0 0 .255.098c.098 0 .19-.037.255-.098l2.958-2.787a.89.89 0 0 0 .285-.646c0-.239-.1-.471-.285-.646a1.04 1.04 0 0 0-.71-.276",
  clipRule: "evenodd"
})));
export default SvgFile;